export const API_URL = "https://backend.losersmagnifiques.com/api/"
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY
export const FACEBOOK_URL =
   "https://www.facebook.com/profile.php?id=100088446973278"
export const INSTAGRAM_URL = "https://www.instagram.com/losersmagnifiques/"
export const TWITTER_URL = "https://twitter.com/LM_eyewear"
export const TIKTOK_URL = "https://www.tiktok.com/@losersmagnifiques"
export const CHARACTERS =
   "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
export const EMAILJS_SERVICE = process.env.REACT_APP_EMAILJS_SERVICE_ID
export const EMAILJS_USER = process.env.REACT_APP_EMAILJS_PUBLIC_KEY

export const heroImageItems = [
   {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/HeroImages%2FJohan_homepage.webp?alt=media&token=ee5e42ef-2f29-42e3-9ef3-c7e1dcd1ef3d",
      titleFr: "Lunettes optiques et solaires",
      titleEn: "Optical and sun eyewear",
      descFr: "Nouvelle collection bientôt disponible",
      descEn: "New collection available soon",
      bg: "transparent",
      button: true,
      buttonLink: "/new-collection",
   },
   {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/HeroImages%2FAlly_opticalpage.webp?alt=media&token=88485952-13a6-438a-bb7e-7e478471fdf9",
      titleFr: "Collection Optique",
      titleEn: "Optical Collection",
      descFr:
         "Un design qui incarne toutes les dimensions du loser magnifique : décalé, élégant et intemporel. Des modèles uniques au design épuré et créatif.",
      descEn:
         "A design that embodies all the dimensions of the magnificent loser: quirky, elegant and timeless. Unique models with clean, creative design.",
      bg: "transparent",
      button: false,
      buttonLink: "",
   },
   {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/HeroImages%2FJohnny_sunpage.webp?alt=media&token=4604b6d5-cac2-4ede-a27f-4c95849f3c87",
      titleFr: "Collection Solaire",
      titleEn: "Sun collection",
      descFr:
         "La collection solaire Losers Magnifiques est dotée de verres polarisants garantissant une protection maximale contre les UV, une perception des couleurs plus contrastée et l’élimination des reflets éblouissants.",
      descEn:
         "The Losers Magnifiques sunglasses collection features polarized lenses for maximum UV protection, sharper color perception and the elimination of glare.",
      bg: "transparent",
      button: false,
      buttonLink: "",
   },
   {
      id: 4,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Categories%2FSwag_category2.webp?alt=media&token=1ee950d1-c0ea-4ad4-a5f6-658c33c14444",
      titleFr: "Losers Shop Accessoires",
      titleEn: "Losers Shop Accessories",
      descFr: "",
      descEn: "",
      bg: "transparent",
      button: false,
      buttonLink: "",
   },
   {
      id: 5,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/HeroImages%2FAlly_opticalpage.webp?alt=media&token=88485952-13a6-438a-bb7e-7e478471fdf9",
      titleFr: "Parcourez la collection Optique",
      titleEn: "Have a glance at our Optical Collection",
      descFr:
         "Un design qui incarne toutes les dimensions du loser magnifique : décalé, élégant et intemporel. Des modèles uniques au design épuré et créatif.",
      descEn:
         "A design that embodies all the dimensions of the magnificent loser: quirky, elegant and timeless. Unique models with clean, creative design.",
      bg: "transparent",
      button: true,
      buttonLink: "/products/optical",
   },
]

export const categories = [
   {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Categories%2FRaymond_Optical_Category.webp?alt=media&token=d4bc1bb3-a9da-468d-8f3b-346cd023ed2c",
      titleFr: "Collection Optique",
      titleEn: "Optical Collection",
      category: "optical",
   },
   {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Categories%2FShirley_Sun_Category.webp?alt=media&token=8875f3d7-aa40-42ad-8a7e-2c460e3d5997",
      titleFr: "Collection Solaire",
      titleEn: "Sun Collection",
      category: "sun",
   },
   {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Categories%2FSwag_category.webp?alt=media&token=46f189be-b4ca-4ace-a5f0-bbb068bae589",
      titleFr: "Losers Shop Accessoires",
      titleEn: "Losers Shop Accessories",
      category: "accessory",
   },
]

export const pages = [
   {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Pages%2FStory-cover.webp?alt=media&token=b8616563-e6b5-47d8-aa5c-e9197879f663",
      titleFr: "Losers Magnifiques, toute une histoire",
      titleEn: "Story of Losers Magnifiques",
      link: "/story",
   },
   {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/Pages%2FFactory-cover.webp?alt=media&token=9dabaab9-2cac-4d71-a032-d9bb32057ad3",
      titleFr: "Made In France",
      titleEn: "Made In France",
      link: "/mif",
   },
]

export const emailTemplates = [
   {
      name: "newsletter",
      lang: "en",
      id: "",
   },
   {
      name: "newsletter",
      lang: "fr",
      id: "",
   },
   {
      name: "contactForm",
      lang: "en",
      id: "template_yyr4qvd",
   },
   {
      name: "contactForm",
      lang: "fr",
      id: "template_62xehyu",
   },
]

export const colors = [
   { value: "black", translate: "c1" },
   { value: "crystal", translate: "c2" },
   { value: "goldyellow", translate: "c3" },
   { value: "goldpink", translate: "c15" },
   { value: "silver", translate: "c4" },
   { value: "turtle", translate: "c5" },
   { value: "blue", translate: "c6" },
   { value: "red", translate: "c7" },
   { value: "green", translate: "c8" },
   { value: "grey", translate: "c9" },
   { value: "orange", translate: "c10" },
   { value: "yellow", translate: "c11" },
   { value: "purple", translate: "c12" },
   { value: "pink", translate: "c13" },
   { value: "brown", translate: "c14" },
   { value: "panther", translate: "c16" },
   { value: "ruthenium", translate: "c17" },
   { value: "all", translate: "c0" },
]

export const sizes = [
   { value: "1", translate: "t1" },
   { value: "2", translate: "t2" },
   { value: "3", translate: "t3" },
   { value: "4", translate: "t4" },
   { value: "all", translate: "t0" },
]

export const genders = [
   { value: "m", translate: "g1" },
   { value: "f", translate: "g2" },
   { value: "u", translate: "g3" },
   { value: "all", translate: "g0" },
]
